import { Table as AntTable } from 'antd';

export const TableSummary = (): null => {
  return null;
};

TableSummary.Cell = AntTable.Summary.Cell;
TableSummary.Row = AntTable.Summary.Row;
